<template lang="pug">

  transition(name="fade")

    #home-star-rating(role="img" :aria-label="altCopy")
      star-icon(:star_index="5" :show="show" @navigate="onNavigate")
      star-icon(:star_index="4" :show="show" @navigate="onNavigate")
      star-icon(:star_index="3" :show="show" @navigate="onNavigate")
      star-icon(:star_index="2" :show="show" @navigate="onNavigate")
      star-icon(:star_index="1" :show="show" @navigate="onNavigate")

</template>

<script>

import { mapState, mapMutations, mapGetters } from 'vuex'
import { PATHS, HOME, MODAL_STATES } from 'src/config/app'
import { map } from '@/helpers/MathUtils'
import StarIcon from '@/components/home/Stars/star-icon'

export default {

  components: {
    StarIcon
  },

  props: { 
    show: Boolean
  },

  data() {
    return {
      ariaOptions: [
        'home-alt-tag-star-five-image',
        'home-alt-tag-star-four-image',
        'home-alt-tag-star-three-image',
        'home-alt-tag-star-two-image',
        'home-alt-tag-star-one-image',
      ]
    }
  },

  computed: {

    ...mapState('app', [
      'home',
      'modal_state'
    ]),

    altCopy(){
      return this.lang_en[this.ariaOptions[this.home.section_index-1]]
    }
  },

  created(){ },

  mounted() {},

  beforeDestroy() {},

  methods: {

    ...mapMutations('app', [
      'setHomeSectionByIndex',
      'setModalState'
    ]),

    onNavigate( index ){
      this.setHomeSectionByIndex( index )
    }
  },

  watch: {

  },

}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#home-star-rating
  height: 100%
  position: relative
  justify-content: center
  display: flex
  flex-direction: row
  padding: 0
  z-index: 4
  justify-content: flex-start
  padding: 1rem 0
  margin-left: -.35rem 
  // opacity: 0


</style>
